@if (activeDepositCurfew) {
    <show-message [type]="messageType.INFO">
        <div info>
            <span>{{ 'PARTY.CASHIER.web.deposit.curfew.new.message1' | translate }}</span>
            <a href="{{ depositCurfewRedirectUrl }}" target="_top" class="ml-1">{{ 'PARTY.CASHIER.web.deposit.curfew.new.message2' | translate }}</a>
        </div>
    </show-message>
}
<app-ada-message />
<app-play-break-message />
<app-arc-message />
<app-pl-verification-message />
<app-rev-notification />
<app-session-limits />
@if (isEsRiskPlayer) {
    <show-message [type]="messageType.INFO">
        <div info>
            <strong>{{ 'PARTY.CASHIER.web.deposit.risk.player.message' | translate }}</strong>
            <a (click)="liveChatUrlRisky()">
                <span class="float-right">
                    <b>
                        {{ 'PARTY.CASHIER.web.arc.deposit.limits.intervention.liveChat' | translate }}
                    </b>
                </span>
            </a>
        </div>
    </show-message>
}
@if (depositService.showVATTaxMessage()) {
    @if (showVATInfoMessage()) {
        <show-message [type]="messageType.INFO" [showClose]="true" (close)="closeToaster()" class="vat-info_message">
            <div info>
                <p [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.vatTaxInfo.text2' | translate"></p>
            </div>
        </show-message>
    } @else {
        <show-message [type]="messageType.WARNING">
            <div warning>
                <p [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.vatTaxInfo.text' | translate"></p>
            </div>
        </show-message>
    }
}
@if (userData?.configParams?.isSpainExpiryKycRefreshCheckEnabled == 'Y' && ['600', '602'].includes(userData?.configParams?.rekycSubErrorCode)) {
    <show-message [type]="messageType.WARNING">
        <div warning>
            <p class="text-bold">{{ 'PARTY.CASHIER.web.deposit.expiredId.within.gracePeriod.text1' | translate }}</p>
            @if (userData?.configParams?.rekycSubErrorCode == '600') {
                <p>{{ 'PARTY.CASHIER.web.deposit.expiredId.within.gracePeriod.text2' | translate }}</p>
            } @else if (userData?.configParams?.rekycSubErrorCode == '602') {
                <p>{{ 'PARTY.CASHIER.web.deposit.expiredId.within.gracePeriod.text3' | translate }}</p>
            }
            <a
                class="float-right text-bold text-decoration-none mt-2"
                href="{{ userData?.configParams?.rekycUrl + '&cashierQd=true' }}"
                target="_top"
                (click)="updateNowCta()"
                >{{ 'PARTY.CASHIER.web.deposit.expiredId.updateNow.cta' | translate }}</a
            >
        </div>
    </show-message>
}
@if (showMLLinterceptor && userData?.configParams?.limitType) {
    <show-message [type]="messageType.WARNING">
        <div warning>
            <strong> {{ 'PARTY.CASHIER.web.deposit.pegasus.mll.interceptor.header' | translate }} </strong>
            <p class="line-space">
                {{
                    (userData?.configParams?.limitType?.toLowerCase() == 'calendar'
                        ? 'PARTY.CASHIER.web.deposit.pegasus.mll.interceptor.text.calendar'
                        : 'PARTY.CASHIER.web.deposit.pegasus.mll.interceptor.text.rolling'
                    )
                        | translate
                            : {
                                  limit: userData?.configParams?.limit | vnCurrency,
                              }
                }}
            </p>
            <p class="line-space">{{ 'PARTY.CASHIER.web.deposit.pegasus.mll.interceptor.text3' | translate }}</p>
        </div>
    </show-message>
    <div class="d-flex justify-content-center mb-2">
        <a (click)="mllInterceptorClick(true)" type="button" class="btn btn-secondary d-flex align-items-center mr-3">
            {{ 'PARTY.CASHIER.web.deposit.pegasus.keepLimit.cta' | translate }}
        </a>
        <a
            (click)="mllInterceptorClick(false)"
            href="{{ userData?.configParams?.limitUrl }}"
            target="_top"
            type="button"
            class="btn btn-primary d-flex align-items-center">
            {{ 'PARTY.CASHIER.web.deposit.pegasus.setLimit.cta' | translate }}
        </a>
    </div>
}
